export default __webpack_public_path__ + "static/media/login.1f9c17f9.png";